import { TFunction } from 'i18next';
import { FC } from 'react';
import { LandingIcon, LocationsIcon, ReviewIcon } from '@/shared/ui';
import type { IconProps } from '@chakra-ui/react';

export const brand = 'LocalProf';
export const email = 'support@localprof.com';
export const prodUrl = 'https://localprof.com';
export const address = 'United States: 1309 Coffeen Avenue STE 1200 Sheridan, 82801';

export const instagramLink = 'https://www.instagram.com/local_prof';
export const fbLink = 'https://www.facebook.com/localprof.usa';

export const headerHeight = '4rem';

interface INavLinkItem {
  name: string;
  description: string;
  Icon: FC<IconProps>;
  href: string;
}
interface INavLinks {
  title: string;
  href?: string;
  items?: INavLinkItem[];
}

export const getNavLinks = (t: TFunction): INavLinks[] => [
  {
    title: t('common.footer.navigation.products'),
    items: [
      {
        name: t('common.footer.navigation.locals'),
        description: t('common.footer.navigation.localsDescription'),
        Icon: LocationsIcon,
        href: '/products/locals',
      },
      {
        name: t('common.footer.navigation.reviews'),
        description: t('common.footer.navigation.reviewsDescription'),
        Icon: ReviewIcon,
        href: '/products/reviews',
      },
      {
        name: t('common.footer.navigation.pages'),
        description: t('common.footer.navigation.pagesDescription'),
        Icon: LandingIcon,
        href: '/products/pages',
      },
    ],
  },
  { title: t('common.footer.navigation.features'), href: '/#features' },
  { title: t('common.footer.navigation.whoIsThisFor'), href: '/#who-is-this-for' },
  { title: t('common.footer.navigation.pricing'), href: '/pricing' },
  { href: '/store/products', title: t('common.footer.navigation.store') },
];

export const getPrivacyPages = (t: TFunction) => [
  { name: t('common.footer.navigation.termsAndConditions'), url: 'terms' },
  { name: t('common.footer.navigation.cookiePolicy'), url: 'cookie' },
  { name: t('common.footer.navigation.privacyPolicy'), url: 'privacy' },
];
